import { render, staticRenderFns } from "./CalendarBlock.vue?vue&type=template&id=9818934e&scoped=true&"
import script from "./CalendarBlock.vue?vue&type=script&lang=js&"
export * from "./CalendarBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBlock.vue?vue&type=style&index=0&id=9818934e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9818934e",
  null
  
)

export default component.exports